const setBlockTitleHeight = (selector) => {
    const titles = document.querySelectorAll(selector + ' .ks-same-height-title');
    if (titles.length <= 1) return;
    const setTitleHeight = () => {
        if (window.innerWidth >= 768) {
            let maxHeight = 0;
            // Erstens, finde die maximale Höhe
            titles.forEach(title => {
                title.style.height = '';
                const titleHeight = title.offsetHeight;
                maxHeight = Math.max(maxHeight, titleHeight);
            });
            // Zweitens, setze die maximale Höhe für alle Titel
            titles.forEach(title => {
                title.style.height = maxHeight + 'px';
            });
        } else {
            // Entferne die Höheneinstellungen für alle Titel, wenn nicht Desktop
            titles.forEach(title => {
                title.style.height = '';
            });
        }

    };

    /* Die Funktion optimizedResize verwendet ein Timeout, um zu verhindern, dass setTitleHeight zu oft aufgerufen wird. Dies ist besonders nützlich bei schnellen und wiederholten Fenstergrößenänderungen wie beim Dragging des Fensterrandes. */
    let resizeTimeout = null;
    const optimizedResize = () => {
        return () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(setTitleHeight, 100); // Setzt die Höhe nach 100ms, um excessive Aufrufe zu vermeiden
        };
    };
    window.addEventListener('resize', optimizedResize());
    setTitleHeight();
};
export default setBlockTitleHeight;
